import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withStyles, Grid } from '@material-ui/core';
import { UserCard, FHEContainer, FHEContainerScroll, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { SvgSDM20LHT } from 'data/common/iconsvg';

import {
    getSDM20LHTDetails,
    refreshSDM20LHTStatus,
    switchSDM20LHTMaster,
    dissociateSDM20LHTUser,
    dissociateSDM20LHTUserAndSwitchMaster
} from '../../data/SDM20LHT/actions';

class SDM20LHTDetail extends PureComponent {
    static propTypes = {
        getSDM20LHTDetails: PropTypes.func.isRequired,
        dissociateSDM20LHTUser: PropTypes.func.isRequired,
        dissociateSDM20LHTUserAndSwitchMaster: PropTypes.func.isRequired,
        switchSDM20LHTMaster: PropTypes.func.isRequired,
        refreshSDM20LHTStatus: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        SDM20LHT: PropTypes.object,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        SDM20LHT: new Map()
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            actionDisabled: false
        };
    }

    componentDidMount() {
        this.getSDM20LHTDetails();
    }

    getSDM20LHTDetails = () => {
        const { getSDM20LHTDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        getSDM20LHTDetails(match.params.SDM20LHTId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    switchSDM20LHTMaster = (SDM20LHTMac, userId) => {
        const { switchSDM20LHTMaster } = this.props;

        return switchSDM20LHTMaster(SDM20LHTMac, userId)
            .then(data => {
                Toastr.success(Translator.translate('generic.user.actions.switchSuccess'));
                return data;
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.switchError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM20LHTUser = (SDM20LHTMac, userId) => {
        const { dissociateSDM20LHTUser } = this.props;

        return dissociateSDM20LHTUser(SDM20LHTMac, userId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM20LHTUserAndSwitchMaster = (SDM20LHTMac, userId, masterId) => {
        const { dissociateSDM20LHTUserAndSwitchMaster } = this.props;

        return dissociateSDM20LHTUserAndSwitchMaster(SDM20LHTMac, userId, masterId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    enableActions = () => {
        this.setState({
            actionDisabled: false
        });
    };

    disableActions = () => {
        this.setState({
            actionDisabled: true
        });
    };

    refreshStateSDM20LHT = SDM20LHTMac => {
        const { refreshSDM20LHTStatus } = this.props;
        return refreshSDM20LHTStatus(SDM20LHTMac)
            .then(() => {
                Toastr.success(Translator.translate('general.products.SDM20LHT.table.action.refresh.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('general.products.SDM20LHT.table.action.refresh.error')
                );
                throw err;
            });
    };

    renderUserList() {
        const { usersLoading, actionDisabled } = this.state;
        const { SDM20LHT, profile } = this.props;
        const users = [];

        if (!usersLoading && SDM20LHT.has('otherUsers')) {
            SDM20LHT.get('otherUsers').map(user => {
                const isMaster = SDM20LHT.get('userMasterId') === user.get('_id');
                let otherUsers = [];
                if (isMaster) {
                    SDM20LHT.get('otherUsers').map(user => {
                        if (user.get('_id') !== SDM20LHT.get('userMasterId'))
                            otherUsers.push({ id: user.get('_id'), label: `${user.get('firstname')} ${user.get('lastname')}` });
                    });
                }
                users.push(
                    <Grid key={user.get('_id')} container item sm={12} md={6} xl={4}>
                        <UserCard
                            isMaster={isMaster}
                            user={user}
                            profile={profile}
                            product={SDM20LHT}
                            productName="SDM20LHT"
                            environment="myfhe"
                            dissociateUserFunc={this.dissociateSDM20LHTUser}
                            dissociateUserAndSwitchMasterFunc={this.dissociateSDM20LHTUserAndSwitchMaster}
                            switchMasterFunc={this.switchSDM20LHTMaster}
                            actionDisabled={actionDisabled}
                            disableActions={this.disableActions}
                            enableActions={this.enableActions}
                            otherUsers={otherUsers}
                        />
                    </Grid>
                );
            });
            return (
                <Grid container spacing={3}>
                    {users}
                </Grid>
            );
        }
    }
    renderPartDetail = () => {
        const { SDM20LHT } = this.props;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.switchState1')}
                        itemContent={Translator.translate(`general.products.SDM20LHT.table.data.switchState.${SDM20LHT.get('switchState1')}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.switchState2')}
                        itemContent={Translator.translate(`general.products.SDM20LHT.table.data.switchState.${SDM20LHT.get('switchState2')}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.relayType')} itemContent={SDM20LHT.get('relayType')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.mode')}
                        itemContent={Translator.translate(`general.data.mode.${SDM20LHT.get('mode')}`)}
                    />
                </Grid>
            </Grid>
        );
    };

    renderChildren = () => {
        const { loading } = this.state;
        const { SDM20LHT, classes } = this.props;
        return (
            <Fragment>
                <FHETitle title={SDM20LHT.get('label')} Icon={SvgSDM20LHT} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.macAddress')}
                                    itemContent={
                                        SDM20LHT.get('macAddress')
                                            ? SDM20LHT.get('macAddress')
                                                  .match(/.{1,2}/g)
                                                  .join(':')
                                            : 'N/A'
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                                    itemContent={SDM20LHT.get('firmwareVersion')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.products.SDM20LHT.table.action.refresh.tooltip')}
                                    onClick={this.refreshStateSDM20LHT}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${SDM20LHT.get('state')}`)}
                                    classContent={SDM20LHT.get('state') === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={SDM20LHT.get('userEmail')} />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.details')} />

                    <FHEContainerForm loading={loading} onRender={this.renderPartDetail} />

                    <FHEDivider title={Translator.translate('general.Users')} />
                    {this.renderUserList()}
                </FHEContainerScroll>
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getSDM20LHTDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const users = state.environments.myfhe.data.Users.get('list');

    let SDM20LHT = state.environments.myfhe.data.SDM20LHT.getIn(['list', props.match.params.SDM20LHTId], new Map());
    if (SDM20LHT && users) {
        let otherUsers = [];
        let masterUser = new Map();
        if (SDM20LHT.get('usersList')) {
            SDM20LHT.get('usersList').forEach(userId => {
                users.find(user => {
                    if (userId === user.get('_id')) {
                        if (masterUser.size === 0 && SDM20LHT.get('userMasterId') === user.get('_id')) {
                            masterUser = user;
                            otherUsers.unshift(user);
                        } else {
                            otherUsers.push(user);
                        }
                    }
                });
            });
            SDM20LHT = SDM20LHT.setIn(['userEmail'], masterUser.get('email')).setIn(['otherUsers'], otherUsers);
        }
    }
    return {
        profile: state.data.user,
        SDM20LHT,
        initialized: state.environments.myfhe.data.SDM20LHT.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators(
                { getSDM20LHTDetails, refreshSDM20LHTStatus, switchSDM20LHTMaster, dissociateSDM20LHTUser, dissociateSDM20LHTUserAndSwitchMaster },
                dispatch
            )
    )(withStyles(styles, { withTheme: true })(SDM20LHTDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM20LHT/details.js